import { render } from "./GettingStarted.vue?vue&type=template&id=f9804118&scoped=true"
import script from "./GettingStarted.vue?vue&type=script&lang=js"
export * from "./GettingStarted.vue?vue&type=script&lang=js"

import "./GettingStarted.vue?vue&type=style&index=0&id=f9804118&lang=scss&scoped=true"

import exportComponent from "/home/lexmodo/projects/waitlist/waitlist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9804118"]])

export default __exports__